export const CHUNK_LOAD_FAILED_TAG = 'chunk_load_failed';

export const CHUNK_URL_TAG = 'chunk_url';

export const WEB_VITALS_CHUNK = 'web-vitals';

export const UNHANDLED_CHUNK = 'unhandled';

export const UNKNOWN_CHUNK_URL = 'unknown';

export const MODULE_SCRIPT_ERROR_PATTERNS = [
    /Importing a module script failed/, // WebKit
    /error loading dynamically imported module/i, // Firefox
];

export const PAGE_IN_BACKGROUND_TAG = 'page_in_background';

export const RESOURCE_TIMING_BUFFER_SIZE = 250;
